export default "__VITE_ASSET__9deb8514__"